import { useAppDispatch } from '../hooks/useAppDispatch';
import { completeStepAction, setHasViewedCompanyDomain } from '../store/flow/action-creators';
import { Step } from 'signup-constants/Step';
export const useView = ({
  stepKey
}) => {
  const dispatch = useAppDispatch();
  const submit = () => {
    if (!stepKey) {
      throw new Error('stepKey is required');
    }
    dispatch(completeStepAction({
      stepKey
    }));
    if (stepKey === Step.CompanyDomain) {
      dispatch(setHasViewedCompanyDomain());
    }
  };
  return {
    submit
  };
};